import { LitElement, html } from 'lit-element';

export default class VideoLogo extends LitElement {

  constructor() {
    super();

    this.isMounted = false;
  }

  static get properties() {
    return {
      src: {type: String},
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`<video
      src="${this.src}"
      autoplay
      muted
      @ended="${this.loopVideo}"
    ></video>`;
  }

  loopVideo(event) {
    const element = event.target;
    setTimeout(() => {
      if (!this.isConnected || !element) {
        return;
      }
      element.play();
    }, 10 * 1000); // 10 seconds
  }
}

// Register the element with the browser
customElements.define('video-logo', VideoLogo);
